


































import { Component, Vue, Prop, Provide } from 'vue-property-decorator'
import Account from './components/account/index.vue'
import BaseInfo from './components/baseInfo/index.vue'
import School from './components/school/index.vue'
@Component({
  components: {
    Account,
    BaseInfo,
    School
  }
})
export default class Home extends Vue {
  // 1账号密码、2基本信息、3院校注册
  public currentTab = 1
  // 注册信息
  public registerInfo = {
    // 手机号
    phone: '',
    // 密码
    password: '',
    // 验证码
    verification_code: '',
    // 学段
    ktwelve: '',
    // 学科
    subject: '',
    // 姓名
    realname: '',
    // 学校名字
    school_name: '',
    // 学校对应区域码
    school_region_code: '',
    // 学校id
    school_id: ''
  }
  // 切换注册界面
  public changeCurrnetTab(val, obj) {
    // 合并传入的参数
    obj && Object.assign(this.registerInfo, obj)
    this.currentTab = val
  }

  public mounted() {
    const env = process.env.VUE_APP_MODE || 'development'
    window['sensors'].registerPage({
      platform: 'Web',
      product: '内容库',
      env
    })
    setTimeout(() => {
      window['sensors'].quick('autoTrack')
    }, 50)
  }
}
